<template>
  <b-table
    :items="items"
    :fields="fields.filter((each) => each.selected)"
    :hover="true"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :per-page="0"
    :current-page="currentPage"
    @row-selected="onRowSelected"
    select-mode="single"
    selectable
    show-empty
    label-sort-asc=""
    label-sort-desc=""
    label-sort-clear=""
    sort-icon-right
    :no-border-collapse="true"
    responsive="lg"
    :thead-class="`table-thead text-center bg-transparent ${theadClass}`"
    :tbody-class="`table-tbody text-center ${tbodyClass}`"
    ref="selectableTable"
    info="true"
    id="drivers_table"
    class="new-theme-custom-table"
  >
    <template #empty> {{ $t('empty-row') }} </template>

    <template #cell(provider)="{ item }">
      <div class="d-flex justify-content-evenly">
        <div v-if="item.img">
          <img :src="require(`@/assets/images/${item.img}.svg`)" />
        </div>
        <div>{{ item.provider }}</div>
      </div>
    </template>

    <template #cell(rating)="{ item }">
      <div class="d-flex justify-content-evenly">
        <div class="rating">{{ item.rating }}</div>
        <img :src="require(`@/assets/images/icons/star.svg`)" alt="star" />
      </div>
    </template>

    <template #cell(action)="{ item }">
      <div class="d-flex justify-content-evenly">
        <b-dropdown v-if="!disabledEdit || !disabledDelete" variant="transparent">
          <div class="d-flex flex-column justify-content-center delete-edit-model">
            <div
              id="driver_Edit_button"
              v-if="!disabledEdit"
              class="d-flex justify-content-center delete-edit-model-text"
              @mouseenter="EditHovered = true"
              @mouseleave="EditHovered = false"
              @click.stop="moveToEdit(item.driverId)"
            >
              <img
                :src="
                  EditHovered
                    ? require('@/assets/images/icons/pincle-edit.svg')
                    : require('@/assets/images/icons/pincle-edit.svg')
                "
                alt="edit"
                width="13"
              />
              <p class="text-center my-2 mx-3">{{ $t('edit') }}</p>
            </div>
            <hr class="my-0" />
            <div
              id="driver_delete_button"
              v-if="!disabledDelete"
              class="d-flex justify-content-center delete-edit-model-text"
              @mouseenter="DeleteHovered = true"
              @mouseleave="DeleteHovered = false"
              @click="openDeleteModel(item.driverId)"
            >
              <img
                :src="
                  DeleteHovered
                    ? require('@/assets/images/icons/trush.svg')
                    : require('@/assets/images/icons/trush.svg')
                "
                alt="edit"
                width="16"
              />
              <p class="text-center my-2 mx-2">{{ $t('delete') }}</p>
            </div>
          </div>
        </b-dropdown>
        <delete-modal :id="item.driverId" @refreshData="filterBySideBar"></delete-modal>
      </div>
    </template>
    <template #cell(active)="data">
      <b-button
        :class="['status-btn', data.item.active ? 'status-btn-true' : 'status-btn-false']"
        >{{ data.item.active ? $t('ready') : $t('not-ready') }}</b-button
      >
    </template>
  </b-table>
</template>

<script>
import DeleteModal from '@/components/Drivers/Listing/deleteModal.vue'

export default {
  components: {
    DeleteModal,
  },
  props: [
    'tbodyClass',
    'theadClass',
    'items',
    'fields',
    'currentPage',
    'sortByProp',
    'sortDescProp',
  ],
  emits: ['changeParentSorting', 'filterBySideBar'],
  data() {
    return {
      EditHovered: false,
      sortBy: '',
      sortDesc: false,
      DeleteHovered: false,
    }
  },
  methods: {
    onRowSelected(items) {
      this.$router.push(`/driver/${items[0].driverId}`).catch(() => {})
    },
    moveToEdit(driversId) {
      this.$router.push(`/driver/Edit/${driversId}`).catch(() => {})
    },
    filterBySideBar() {
      this.$emit('filterBySideBar')
    },
    openDeleteModel(id) {
      this.$bvModal.show(`delete-driver-modal-${id}`)
    },
  },
  computed: {
    disabledEdit() {
      return this.$store.getters['enums/is_not_permitted']('editDriver')
    },
    disabledDelete() {
      return this.$store.getters['enums/is_not_permitted']('deleteDriver')
    },
  },
  watch: {
    sortBy(val) {
      this.$emit('changeParentSorting', val, this.sortDesc)
    },
    sortDesc(val) {
      this.$emit('changeParentSorting', this.sortBy, val)
    },
    sortByProp(val) {
      this.sortBy = val
    },
    sortDescProp(val) {
      this.sortDesc = val
    },
  },
}
</script>
